import { GenericRemoteActionBuilder } from '../remote-action-builder';
import { Injectable, ViewContainerRef, ComponentRef } from '@angular/core';
import { LoggingService } from 'src/app/_services/logging/logic/logging.service';
import { ClientStateService } from 'src/app/_services/client-state/logic/client-state.service';
import { RemoteAction } from '../../remote-action';
import { TimeCorrectionRemoteActionBuilderUiStep } from '../../remote-action-builder-steps/time-correction-remote-action-builder-ui-step/time-correction-remote-action-builder-ui-step';
import { TimeCorrectionComponent } from 'src/app/_components/remote-action-step/time-correction/time-correction.component';
import { WorkingTimeRemoteActionType } from './working-time-remote-action-type';
import { LocationService } from 'src/app/_services/location/location.service';
import { EmployeeService } from 'src/app/_services/employee/logic/employee.service';
import { ServicejobSelectRemoteActionBuilderUIStep } from '../../remote-action-builder-steps/servicejob-select-remote-action-builder-ui-step/servicejob-select-remote-action-builder-ui-step';
import { PlaceTypeRemoteActionBuilderServiceStep } from '../../remote-action-builder-steps/placetype-remote-action-builder-service-step/placetype-remote-action-builder-service-step';
import { ServicejobSelectRaStepComponent } from 'src/app/_components/remote-action-step/servicejob-select-ra-step/servicejob-select-ra-step.component';
import { ServicejobIdRemoteActionBuilderServiceStep } from '../../remote-action-builder-steps/servicejob-id-remote-action-builder-service-step/servicejob-id-remote-action-builder-service-step';
import { AppService } from 'src/app/_services/app-service/logic/app.service';
import { CredentialsService } from 'src/app/_services/credentials/logic/credentials.service';
import { SystemState } from 'src/app/_model/client-state';
import { ServicejobsService } from 'src/app/_services/servicejobs/logic/servicejobs.service';
import { ActivityTypeSelectRemoteActionBuilderUIStep } from '../../remote-action-builder-steps/activity-type-select-remote-action-builder-ui-step/activity-type-select-remote-action-builder-ui-step';
import { KeywordSelectRemoteActionBuilderUIStep } from '../../remote-action-builder-steps/keyword-select-remote-action-builder-ui-step/keyword-select-remote-action-builder-ui-step';
import { GpsRemoteActionBuilderServiceStep } from '../../remote-action-builder-steps/gps-remote-action-builder-service-step/gps-remote-action-builder-service-step';
import { AppParameterService } from 'src/app/_services/app-parameter/logic/app-parameter.service';
import { ExecutedWorkRemoteActionBuilderUiStep } from '../../remote-action-builder-steps/executed-work-remote-action-builder-ui-step/executed-work-remote-action-builder-ui-step';
import { TeamRemoteActionBuilderServiceStep } from '../../remote-action-builder-steps/team-remote-action-builder-service-step/team-remote-action-builder-service-step';
import { OvernightStayRemoteActionBuilderUiStep } from '../../remote-action-builder-steps/overnight-stay-remote-action-builder-ui-step copy/overnight-stay-remote-action-builder-ui-step';
import { OtherPlaceTextRemoteActionBuilderUiStep } from '../../remote-action-builder-steps/other-place-text-remote-action-builder-ui-step/other-place-text-remote-action-builder-ui-step';
import { LBSUtils } from 'src/app/_util/lbs-utils';
import { CarSelectRemoteActionBuilderUiStep } from '../../remote-action-builder-steps/car-select-remote-action-builder-ui-step/car-select-remote-action-builder-ui-step';
import { CarSelectRaStepComponent } from 'src/app/_components/remote-action-step/car-select-ra-step/car-select-ra-step.component';
import { DriverSelectRemoteActionBuilderUiStep } from '../../remote-action-builder-steps/driver-select-remote-action-builder-ui-step/driver-select-remote-action-builder-ui-step';
import { JobSectionRemoteActionBuilderUiStep } from '../../remote-action-builder-steps/jobsection-select-remote-action-builder-ui-step/jobsection-select-remote-action-builder-ui-step';
import { JobSectionsService } from 'src/app/_services/job-section/logic/job-section.service';
import { JobSectionSelectRaStepComponent } from 'src/app/_components/remote-action-step/jobsection-select-ra-step/jobsection-select-ra-step.component';
import { TeamConfirmationRemoteActionBuilderUiStep } from '../../remote-action-builder-steps/team-confirmation-remote-action-builder-ui-step/team-confirmation-remote-action-builder-ui-step';

@Injectable()
export class WorkingTimeRemoteActionBuilder extends GenericRemoteActionBuilder {
  constructor(
    private type: WorkingTimeRemoteActionType,
    private clientStateService: ClientStateService,
    appService: AppService,
    credentialsService: CredentialsService,
    private servicejobService: ServicejobsService,
    locationService: LocationService,
    employeeService: EmployeeService,
    jobSectionsService: JobSectionsService,
    private appParameterService: AppParameterService,
    private logger?: LoggingService
  ) {
    super(
      type.pageTitle,
      appService,
      credentialsService,
      {
        endpoint: type.endpoint,
        data: {},
        cachable: true,
        fifo: true,
        authenticationRequired: true,
        shortLabel: type.raShortLabel,
        shortLabelTranslate: true,
      },
      // Start of Work we need to provide additionally the possibility to directly
      // start a servicejob.
      type === WorkingTimeRemoteActionType.START_OF_WORK
        ? []
            .concat(
              appParameterService.appParameters$.getValue()?.[
                'imsmc.workstart.useteamconfirmation'
              ]
                ? [new TeamConfirmationRemoteActionBuilderUiStep(logger)]
                : []
            )
            .concat(
              !appParameterService.appParameters$.getValue()[
                'imsmc.objectbased'
              ] ||
                appParameterService.appParameters$.getValue()[
                  'imsmc.workstart.allow.homeplace'
                ] ||
                appParameterService.appParameters$.getValue()[
                  'imsmc.workstart.allow.otherplace'
                ] ||
                appParameterService.appParameters$.getValue()[
                  'imsmc.workstart.allow.workplace'
                ]
                ? [
                    new ServicejobSelectRemoteActionBuilderUIStep(logger),
                    new OtherPlaceTextRemoteActionBuilderUiStep(logger),
                    new JobSectionRemoteActionBuilderUiStep(
                      jobSectionsService,
                      logger
                    ),
                    new JobSectionRemoteActionBuilderUiStep(
                      jobSectionsService,
                      logger
                    ),
                    new JobSectionRemoteActionBuilderUiStep(
                      jobSectionsService,
                      logger
                    ),
                    new JobSectionRemoteActionBuilderUiStep(
                      jobSectionsService,
                      logger
                    ),
                  ]
                : []
            )
            .concat(
              LBSUtils.convertStringBool(
                appParameterService.appParameters$.getValue()[
                  'imsmc.workstart.usecarselection'
                ],
                false
              )
                ? [new CarSelectRemoteActionBuilderUiStep(logger)]
                : []
            )
            .concat(
              LBSUtils.convertStringBool(
                appParameterService.appParameters$.getValue()[
                  'imsmc.workstart.usedriverflag'
                ],
                false
              )
                ? [new DriverSelectRemoteActionBuilderUiStep(logger)]
                : []
            )
            .concat(
              appParameterService.appParameters$.getValue()[
                'imsmc.force.trip.close.on.eow'
              ] != true &&
                appParameterService.appParameters$.getValue()[
                  'imsmc.tripgen.overnightstaywithoutreceipt'
                ] == true &&
                clientStateService.theState.getValue().lastKnownPlace !=
                  undefined &&
                clientStateService.theState.getValue().activeBtrip == true
                ? [new OvernightStayRemoteActionBuilderUiStep(logger)]
                : []
            )
            .concat([new TimeCorrectionRemoteActionBuilderUiStep(logger)])
        : // If a ServiceJob is aktive we are not in Pause and go to pause or end of work we need
        // to transmit the activity type and keyword for the servicejob
        clientStateService.theState.getValue().serviceJobId &&
          clientStateService.theState.getValue().getSystemState() !==
            SystemState.PAUSESTARTED &&
          clientStateService.theState.getValue().getSystemState() !==
            SystemState.WAITSTARTED &&
          (type === WorkingTimeRemoteActionType.START_OF_PAUSE ||
            type === WorkingTimeRemoteActionType.START_OF_WAIT ||
            type === WorkingTimeRemoteActionType.END_OF_WORK)
        ? []
            .concat(
              appParameterService.appParameters$
                .getValue()
                .getBooleanParameter('imsmc.job.reportexecutedwork', true)
                ? [new ExecutedWorkRemoteActionBuilderUiStep(logger)]
                : []
            )
            .concat(
              appParameterService.appParameters$.getValue()[
                'imsmc.job.reportactivitytype'
              ]
                ? [new ActivityTypeSelectRemoteActionBuilderUIStep(logger)]
                : []
            )
            .concat(
              appParameterService.appParameters$.getValue()['imsmc.use.keyword']
                ? [new KeywordSelectRemoteActionBuilderUIStep(logger)]
                : []
            )
            .concat([new TimeCorrectionRemoteActionBuilderUiStep(logger)])
        : [new TimeCorrectionRemoteActionBuilderUiStep(logger)],
      [
        new ServicejobIdRemoteActionBuilderServiceStep(
          clientStateService,
          servicejobService,
          logger
        ),
        new PlaceTypeRemoteActionBuilderServiceStep(clientStateService, logger),
        new TeamRemoteActionBuilderServiceStep(
          employeeService,
          clientStateService,
          logger
        ),
        new GpsRemoteActionBuilderServiceStep(locationService, logger),
      ],
      async (data: any) => {
        logger.log(
          this.constructor.name,
          ' Executing post generate function',
          data
        );

        switch (type) {
          case WorkingTimeRemoteActionType.START_OF_WORK:
            // JB20191022: If Placetype was transmitted. Set this placetype as current placetype
            // JB20200117: APP4-273 only set the placetype if the placetype was really selected
            // otherwise it seems as the user is stuck at the selected pt (e.g. DO)
            if (data['selected_pt']) {
              await this.clientStateService.updatePlace(
                data['selected_pt'],
                data['destinationInfo']
              );
            }

            await this.clientStateService.startWorking();

            // JB20191022: If Servicejob was transmitted. Set this service job as current servicejob
            if (data['next_sjobid']) {
              const checkedSJob = this.servicejobService.getServiceJobById(
                data['next_sjobid']
              );
              if (checkedSJob) {
                await this.clientStateService.setServicejobId(checkedSJob.id);
              } else {
                this.logger.log(
                  this.constructor.name,
                  'provided sjob id is not available, try finding sjob by secondarykey',
                  data['next_sjob_secondarykey']
                );

                if (data['next_sjob_secondarykey']) {
                  const foundSjobsBySecondaryKey =
                    this.servicejobService.servicejobs$
                      .getValue()
                      .filter((val) => {
                        return (
                          data['next_sjob_secondarykey'] ===
                            val.appaccountingnumber ||
                          data['next_sjob_secondarykey'] ===
                            val.accountingnumber
                        );
                      });

                  if (
                    foundSjobsBySecondaryKey &&
                    foundSjobsBySecondaryKey.length > 0
                  ) {
                    if (foundSjobsBySecondaryKey.length === 1) {
                      await this.clientStateService.setServicejobId(
                        foundSjobsBySecondaryKey[0].id
                      );
                    } else {
                      this.logger.warn(
                        this.constructor.name,
                        'Found multiple sjobs for skey take first one'
                      );
                      await this.clientStateService.setServicejobId(
                        foundSjobsBySecondaryKey[0].id
                      );
                    }
                  } else {
                    this.logger.error(
                      this.constructor.name,
                      'Warning no secondary key sjob found'
                    );
                  }
                }
              }

              await this.clientStateService.startServicejob();
            }

            if (data['curjsid']) {
              logger.log(
                this.constructor.name,
                'found jobsection id in remote action update clientstate',
                data['curjsid']
              );
              await this.clientStateService.setJobSectionId(data['curjsid']);
            }

            if (data['curcarid']) {
              await this.clientStateService.setLastUsedCarId({
                imsId: data['curcarid'],
                secondaryId: undefined,
                objRef: 'ims/Car',
              });
            }

            if (data['ishomeofficeday']) {
              await this.clientStateService.setCurrentDayIsHomeOffice(
                LBSUtils.convertStringBool(data['ishomeofficeday'], false)
              );
            }
            if (data['stayedexternal']) {
              await this.clientStateService.setLastDayExternalStay(true);
            }

            if (data['dpflag']) {
              await this.clientStateService.setIsPassenger(
                data['dpflag'] == 'dpp'
              );
            }

            break;
          case WorkingTimeRemoteActionType.END_OF_WORK:
            if (data['sjobid']) {
              const finish = data['sjobfinish'] ? true : false;
              await this.clientStateService.stopServicejob(finish, true);
            }
            if (data['ishomeofficeday']) {
              await this.clientStateService.setCurrentDayIsHomeOffice(
                LBSUtils.convertStringBool(data['ishomeofficeday'], false)
              );
            }
            if (data['willstayedexternal']) {
              await this.clientStateService.setCurrentDayExternalStay(true);
            }
            await this.clientStateService.stopWorking();
            break;
          case WorkingTimeRemoteActionType.START_OF_PAUSE:
            await this.clientStateService.startPause();
            break;
          case WorkingTimeRemoteActionType.END_OF_PAUSE:
            await this.clientStateService.stopPause();
            break;
          case WorkingTimeRemoteActionType.START_OF_WAIT:
            await this.clientStateService.startWait();
            break;
          case WorkingTimeRemoteActionType.END_OF_WAIT:
            await this.clientStateService.stopWait();
            break;
        }
      },
      logger
    );
  }

  public async next(dataValues?: { key: string; value: any }[]): Promise<any> {
    return super.next(dataValues);
  }

  public async generateRemoteAction(
    dataValues: { key: string; value: any }[]
  ): Promise<RemoteAction> {
    return super.generateRemoteAction(dataValues);
  }

  public generateComponent(
    viewContainerRef: ViewContainerRef
  ): ComponentRef<any> {
    const componentRef = super.generateComponent(viewContainerRef);

    // Configure specific Components
    if (componentRef.instance instanceof TimeCorrectionComponent) {
      (<TimeCorrectionComponent>componentRef.instance).setDescription(
        this.type.descriptionKey
      );
      (<TimeCorrectionComponent>componentRef.instance).setTitle(
        this.type.titleKey
      );

      const appParams = this.appParameterService.appParameters$.getValue();
      if (appParams != undefined) {
        switch (this.type) {
          case WorkingTimeRemoteActionType.START_OF_WORK:
            (<TimeCorrectionComponent>componentRef.instance).hideComment =
              appParams.getBooleanParameter(
                'imsmc.remoteaction-step.hidecomment.sow',
                false
              );
            (<TimeCorrectionComponent>(
              componentRef.instance
            )).showHomeOfficeCheckbox = appParams.getBooleanParameter(
              'imsmc.remoteaction-step.showhomeofficeday.sow',
              false
            );
            (<TimeCorrectionComponent>(
              componentRef.instance
            )).showLastNightWasExternalStay = appParams.getBooleanParameter(
              'imsmc.remoteaction-step.externalstayonwtd.sow',
              false
            );
            break;
          case WorkingTimeRemoteActionType.END_OF_WORK:
            (<TimeCorrectionComponent>componentRef.instance).hideComment =
              appParams.getBooleanParameter(
                'imsmc.remoteaction-step.hidecomment.eow',
                false
              );
            (<TimeCorrectionComponent>(
              componentRef.instance
            )).showHomeOfficeCheckbox = appParams.getBooleanParameter(
              'imsmc.remoteaction-step.showhomeofficeday.eow',
              false
            );
            (<TimeCorrectionComponent>(
              componentRef.instance
            )).showComingNightHasExternalStay = appParams.getBooleanParameter(
              'imsmc.remoteaction-step.externalstayonwtd.eow',
              false
            );
            if (
              this.clientStateService.theState.getValue().isPassenger &&
              appParams.getBooleanParameter(
                'imsmc.remoteaction-step.passenger-trip-end.show-on-eow',
                false
              )
            ) {
              (<TimeCorrectionComponent>componentRef.instance).showDPEnd =
                appParams.getBooleanParameter(
                  'imsmc.remoteaction-step.passenger-trip-end.allow-end',
                  false
                );
              (<TimeCorrectionComponent>componentRef.instance).showDPEot =
                appParams.getBooleanParameter(
                  'imsmc.remoteaction-step.passenger-trip-end.allow-eot',
                  false
                );
            }
            break;
          case WorkingTimeRemoteActionType.START_OF_PAUSE:
            (<TimeCorrectionComponent>componentRef.instance).hideComment =
              appParams.getBooleanParameter(
                'imsmc.remoteaction-step.hidecomment.sop',
                false
              );
            break;
          case WorkingTimeRemoteActionType.END_OF_PAUSE:
            (<TimeCorrectionComponent>componentRef.instance).hideComment =
              appParams.getBooleanParameter(
                'imsmc.remoteaction-step.hidecomment.eop',
                false
              );
            break;
          case WorkingTimeRemoteActionType.START_OF_WAIT:
            (<TimeCorrectionComponent>componentRef.instance).hideComment =
              appParams.getBooleanParameter(
                'imsmc.remoteaction-step.hidecomment.sowait',
                false
              );
            break;
          case WorkingTimeRemoteActionType.END_OF_WAIT:
            (<TimeCorrectionComponent>componentRef.instance).hideComment =
              appParams.getBooleanParameter(
                'imsmc.remoteaction-step.hidecomment.eowait',
                false
              );
            break;
        }
      }
    }
    // Configure specific Components
    if (componentRef.instance instanceof ServicejobSelectRaStepComponent) {
      // Tell the component to also show Placetypes
      (<ServicejobSelectRaStepComponent>componentRef.instance).showPlacetypes();
      // JB20200825: In case of object oriented flow do not allow a start of work
      // on a selection of a servicejob.
      const appParams = this.appParameterService.appParameters$.getValue();
      if (
        LBSUtils.convertStringBool(appParams['imsmc.objectbased'], false) ||
        LBSUtils.convertStringBool(
          appParams['imsmc.workstart.allow.servicejobs'],
          true
        ) === false
      ) {
        (<ServicejobSelectRaStepComponent>(
          componentRef.instance
        )).hideServicejobs();
      }
      (<ServicejobSelectRaStepComponent>(
        componentRef.instance
      )).hideFinishedServicejobs();

      this.logger.log(
        this.constructor.name,
        'BtripDebug: allowPreselection?',
        this.appParameterService.appParameters$.getValue()[
          'imsmc.force.trip.close.on.eow'
        ] != true,
        this.clientStateService.theState.getValue().activeBtrip
      );
      if (
        this.appParameterService.appParameters$.getValue()[
          'imsmc.force.lastknownlocation.preselected'
        ] ||
        (this.appParameterService.appParameters$.getValue()[
          'imsmc.force.trip.close.on.eow'
        ] != true &&
          this.clientStateService.theState.getValue().activeBtrip)
      )
        (<ServicejobSelectRaStepComponent>(
          componentRef.instance
        )).allowPreselection();

      if (this.type === WorkingTimeRemoteActionType.START_OF_WORK) {
             (<ServicejobSelectRaStepComponent>(
          componentRef.instance
        )).isStartOfWork = true;
      }
    }

    // Configure specific Components
    if (componentRef.instance instanceof JobSectionSelectRaStepComponent) {
      const currentData = super.getRemoteActionData();
      const appParams = this.appParameterService.appParameters$.getValue();
      if (
        LBSUtils.convertStringBool(
          appParams[
            'imsmc.remoteaction-step.jobsection-select.allow-branch-sections.sow'
          ],
          false
        )
      ) {
        (<JobSectionSelectRaStepComponent>(
          componentRef.instance
        )).allowBranchSelection();
      }

      if (currentData['curjsid']) {
        (<JobSectionSelectRaStepComponent>(
          componentRef.instance
        )).parentJobSectionId = currentData['curjsid'];
      } else if (currentData['next_sjobid']) {
        (<JobSectionSelectRaStepComponent>componentRef.instance).sjobId =
          currentData['next_sjobid'];
      }
    }

    // Configure specific Components
    if (componentRef.instance instanceof CarSelectRaStepComponent) {
      const appParams = this.appParameterService.appParameters$.getValue();

      (<CarSelectRaStepComponent>componentRef.instance).useScanner(
        appParams.getBooleanParameter(
          'imsmc.remoteaction-step.car-select.scanmode',
          false
        )
      );

      if (
        LBSUtils.convertStringBool(
          appParams['imsmc.workstart.preselectedcar'],
          true
        )
      ) {
        (<CarSelectRaStepComponent>componentRef.instance).allowPreselection();
      }
    }

    return componentRef;
  }
}
